<template>
  <div>
    <Head title="Manage Contacts" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl mb-6">
      <form id="form" @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <h1 class="mb-8 font-bold text-3xl">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/contacts">Contacts </Link>
            <span class="text-indigo-400 font-medium">/</span>
            Import Contacts
          </h1>
          <div class="w-full">
            <p>Import contact with the following headers:</p>
            <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3 mb-4">
              <div>
                <ul>
                  <li>first_name</li>
                  <li>last_name</li>
                  <li>email</li>
                  <li>phone</li>
                  <li>sms_enabled</li>
                  <li>email_enabled</li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>type</li>
                  <li>birthday</li>
                  <li>license</li>
                  <li>address</li>
                  <li>city</li>
                  <li>region</li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>country</li>
                  <li>postal_code</li>
                  <li>message</li>
                  <li>automations</li>
                  <li>nickname</li>
                </ul>
              </div>
            </div>

            <FileInput v-model="form.file" type="file" accept=".xlsx, .xls, .csv" label="Select File To Import" :error="form.errors.file" @input="form.file = $event.target.files[0]" />
            <progress v-if="form.progress" :value="form.progress.percentage" max="100" class="w-full">
              {{ form.progress.percentage }}%
            </progress>
          </div>
          <div class="w-full mb-4 mt-4">
            <label>
              <input v-model="form.update" type="radio" :value="true" />
              Update Duplicates
            </label>
            <label class="ml-4">
              <input v-model="form.update" type="radio" :value="false" />
              Skip Duplicates
            </label>
          </div>
          <div class="px-8 py-4 w-full border-t flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Upload</loading-button>
          </div>
        </div>
      </form>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl mb-6">
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <h1 class="mb-8 font-bold text-3xl">
          <Link class="text-indigo-400 hover:text-indigo-600" href="/contacts">Contacts </Link>
          <span class="text-indigo-400 font-medium">/</span>
          Export My Contacts
        </h1>
        <div class="px-8 py-4 w-full border-t flex justify-end items-center">
          <button class="btn-indigo" @click="exportContacts">Download</button>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl mb-6">
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <h1 class="mb-8 font-bold text-3xl">
          <Link class="text-indigo-400 hover:text-indigo-600" href="/contacts">Contacts </Link>
          <span class="text-indigo-400 font-medium">/</span>
          Export All Contacts
        </h1>
        <div class="px-8 py-4 w-full border-t flex justify-end items-center">
          <button class="btn-indigo" @click="exportContactsAll">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
export default {
  components: {
    Head,
    Link,
    FileInput,
    LoadingButton,
  },
  layout: Layout,
  data() {
    return {
      form: router.form({
        file: null,
        update: false,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/contacts/upload')
      this.form.file=''
    },
    exportContacts() {
      const url = '/contacts/export'
      window.location.href = url
    },
    exportContactsAll() {
      const url = '/contacts/exportAll'
      window.location.href = url
    },
  },
}
</script>
